"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildString = void 0;
function buildString(input, sendOptions) {
    if (input !== null && input !== undefined) {
        if (Array.isArray(input)) {
            return input
                .map(function (str, index) {
                return input.length - 1 === index && (sendOptions === null || sendOptions === void 0 ? void 0 : sendOptions.shouldDecameliseEventNames) ? decamelizeText(str) : str;
            })
                .map(function (str) { return formatEventTag(str, sendOptions); })
                .join((sendOptions === null || sendOptions === void 0 ? void 0 : sendOptions.tagClose) ? '' : sendOptions.stringDelimeter);
        }
        else if (input && typeof input === 'object') {
            return JSON.stringify(input);
        }
        var stringInput = String(input) || '';
        return (sendOptions === null || sendOptions === void 0 ? void 0 : sendOptions.shouldDecameliseEventNames) ? decamelizeText(stringInput) : stringInput;
    }
    return '';
}
exports.buildString = buildString;
function formatEventTag(input, sendOptions) {
    return "" + (sendOptions.tagOpen || '') + input + (sendOptions.tagClose || '');
}
function decamelizeText(text) {
    if (!text || text.length < 2 || !/[A-Z]/.test(text)) {
        return text;
    }
    var result = text.replace(/([A-Z])/g, ' $1');
    return result.toLowerCase();
}
